export default __webpack_public_path__ + "static/media/colonialCurrencyShot.88ff8430.jpg";